import { TLink } from "../../../types";
import styles from "./breadcrumbs.module.less";
import { BreadcrumbsList } from "../breadcrumbs-list/breadcrumbs-list";
import LinkWrapper from "../link-wrapper/link-wrapper";
import { useTranslation } from "react-i18next";
import { useAnimateFadeIn } from "../../../animation/animation";
import { m as motion } from "motion/react";

export type TBreadcrumbsProps = {
  items: Array<Partial<TLink>>;
  logoUrl?: string;
};

export const Breadcrumbs = ({ items, logoUrl }: TBreadcrumbsProps) => {
  if (!items) {
    return null;
  }

  const fadeInAnimation = useAnimateFadeIn({ whileInView: false, easing: "easeInOut" });

  const { t } = useTranslation();

  return (
    <section className={`${styles.section}`}>
      <motion.div {...fadeInAnimation} className={`${styles.wrapper} centered max-width padded-sides`}>
        {logoUrl && (
          <LinkWrapper ariaLabel={t("HEADER_LOGO_LINK_ARIA_LABEL")} className={styles.logoWrapper} url={"/"}>
            <img src={logoUrl} alt={"Preem logo"} className={styles.logo} />
          </LinkWrapper>
        )}
        <BreadcrumbsList items={items} />
      </motion.div>
    </section>
  );
};

export default Breadcrumbs;
